import ModalComponent from "../../Assignments/Components/IconInfoRow.jsx";

const ConformationModal = ({
  openModal = false,
  setOpenModal,
  event,
  text,
  size = "md",
  bodyClassName = "",
  sidebarMode = "delete",
  heading = "Delete Confirmation",
  subtitle = "This action is permanent and cannot be undone.",
  primaryButtonText = "Delete",
  confirmTitle = "Confirm deletion",
}) => {
  if (!openModal) return null;

  const normalizedText = String(text || "").trim() || "Are you sure you want to delete this item?";

  return (
    <ModalComponent
      showOverlay
      sidebarMode={sidebarMode}
      heading={heading}
      subtitle={subtitle}
      items={[
        {
          title: confirmTitle,
          desc: normalizedText,
        },
      ]}
      secondaryButtonText="Cancel"
      primaryButtonText={primaryButtonText}
      onSkip={() => setOpenModal(false)}
      onEnable={() => {
        if (event) event();
        setOpenModal(false);
      }}
    />
  );
};

export default ConformationModal;
